import React, {useEffect, useMemo, useState} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select
} from "@mui/material";
import TransitionListView from "../TransitionList";
import {deleteRolePermissions, getRolePermissions, updateRolePermissions} from "./rolesApi";
import {useSelector} from "react-redux";
import {enqueueSnackbar} from "notistack";

export default function EditRolePermissionsDialog({open,setOpen,rowId,}){
    const [attachedPermissions,setAttachedPermissions] = useState([]);
    const [loading,setLoading] = useState(false);
    const [mode,setMode] = useState('attach');
    const [updateList,setUpdateList] = useState([]);
    const allPermissions = useSelector(state=>state.permissionsReducer.permissions)
    function handleClose(){
       setOpen(({
            rowId:null,
            open:false,
        }))
    }
    useEffect(()=>{
        setUpdateList([])
    },[open,mode]);
    useEffect(()=>{
        if(rowId){
            getRolePermissions(rowId).then(({data})=>{
                setAttachedPermissions(data.data)
            });
        }else {
            setAttachedPermissions([])
        }
    },[rowId]);
    const [initialPermissions,initialSelected] = useMemo(()=>{
        
        const detach = {};
        attachedPermissions.forEach(({id,name})=>{
            detach[id]=name
        })

        const attach = {};
        allPermissions.forEach(({id,name})=>{
            if(!detach.hasOwnProperty(id)){
                attach[id]=name
            }
        })
        return [attach,detach]
    },[allPermissions,attachedPermissions])
    function handleAttachRequest(){
       setLoading(true)
       updateRolePermissions(rowId,{
           permission_ids:updateList
       })
           .then(({data})=>{
               setAttachedPermissions(data.data);
               handleClose();
               enqueueSnackbar('Success!',{variant:'success'});
           })
           .catch((e)=>{
               enqueueSnackbar(e.message,{variant:'error'})
           })
           .finally(()=>{
               setLoading(false)
           })
    }
    
    function handleDetachRequest() {
        let params = '?';
        updateList.forEach((id,index)=>{
            params +=`permission_ids[${index}]=${id}${index===(updateList.length-1)?'':'&'}`
        })
        deleteRolePermissions(rowId,params)
            .then(({data})=>{
                setAttachedPermissions(data.data);
                handleClose();
                enqueueSnackbar('Success!',{variant:'success'});
            })
            .catch((e)=>{
                enqueueSnackbar(e.message,{variant:'error'})
            })
            .finally(()=>{
                setLoading(false)
            })
    }
    return <Dialog open={open} sx={{
        '& .MuiPaper-root': {
            width:900,
            maxWidth:'100%',
        }
    }} onClose={handleClose}>
        <DialogContent>
            {loading&&<LinearProgress/>}
            <FormControl fullWidth>
                <InputLabel  id="decline_reason-select-label">Mode</InputLabel>
                <Select
                    fullWidth
                    variant={'outlined'}
                    label={'Mode'}
                    value={mode}
                    onChange={(event)=>{
                        setMode(event.target.value)
                    }}
                >
                    <MenuItem value={'attach'}>
                        Attach
                    </MenuItem>
                    <MenuItem value={'detach'}>
                        Detach
                    </MenuItem>
                </Select>
            </FormControl>
            <TransitionListView
                Title={"Sync permissions to role"}
                selectedButtonText={'Discard all'}
                selectedHeaderText={`Move to  ${mode}`}
                unselectedButtonText={'Select all'}
                unselectedHeaderText={ `Move from ${mode==='attach'?'detach': 'attach'}`}
                printWithId
                elevation={0}
                initialAllElements={mode==='attach'?initialPermissions:initialSelected}
                onChange={(list)=>{
                    setUpdateList(list)
                }}
            />
        </DialogContent>
        <DialogActions>
            <Button color={"error"} onClick={handleClose}>
                Close
            </Button>
            <Button 
                color={"success"}
                disabled={loading}
                onClick={()=>{
                    if(mode==='attach') {
                        handleAttachRequest()
                    }else {
                        handleDetachRequest()
                    }
                }}
            >
                Save
            </Button>
        </DialogActions>
    </Dialog>
}